module.exports = __webpack_public_path__ + "static/nectar-mag-spread-2e908d6dd1f18a83d543770b4d23d41e.jpg";